import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';

import ColorPickerPopover from './ColorPickerPopover.vue';

import StudioColorPickerInput from '@/studioComponents/StudioColorPickerInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionalColorPicker',
  props: {
  id: { type: String, default: '' },
  label: { type: String, default: '' },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  type: { type: String, default: 'color' },
  initialColor: { type: String, default: 'rgba(0, 0, 0, 1)' },
  initialGradient: { type: Object, default: null },
  useFixedPositioning: { type: Boolean, default: false }
},
  emits: ["colorChange", "gradientChange"],
  setup(__props) {

const props = __props;





const store = useStore();

const useAIPageRevamp = computed<boolean>(() => {
  const organization = store.getters['org/getCurrentOrg'];
  return organization?.useAIPageRevamp || false;
});

return (_ctx: any,_cache: any) => {
  return (useAIPageRevamp.value)
    ? (_openBlock(), _createBlock(ColorPickerPopover, {
        key: 0,
        id: __props.id,
        label: __props.label,
        required: __props.required,
        disabled: __props.disabled,
        initialColor: __props.initialColor,
        onColorChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('colorChange', $event)))
      }, null, 8, ["id", "label", "required", "disabled", "initialColor"]))
    : (_openBlock(), _createBlock(StudioColorPickerInput, {
        key: 1,
        id: __props.id,
        label: __props.label,
        type: __props.type,
        initialColor: __props.initialColor,
        initialGradient: __props.initialGradient,
        disabled: __props.disabled,
        useFixedPositioning: __props.useFixedPositioning,
        onColorChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('colorChange', $event))),
        onGradientChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('gradientChange', $event)))
      }, null, 8, ["id", "label", "type", "initialColor", "initialGradient", "disabled", "useFixedPositioning"]))
}
}

})